import { Box } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import BusinessIntroSection from './MainBusinessIntroSection'
import CourseIntroSection from './MainCourseIntroSection'
import XRContentSection from './MainXRContentSection'
import VirtualLabSection from './MainVirtualLabSection'
import SharedPlatformSection from './MainSharedPlatformSection'
import NoticeSection from './MainNoticeSection'
import { useAuth } from '@components/AuthContext';
import { threeMonthCheck } from "@api/main";
import PasswordChangeModal from '@components/Modal/PasswordChangeModal'
import { useLang } from '@/i18n/useLang'

gsap.registerPlugin(ScrollTrigger)

// 접근성: prefers-reduced-motion
function usePrefersReducedMotion() {
  if (typeof window === 'undefined') return false
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export default function Main() {
  const lang = useLang()

  const sectionRefs = useRef([])

  const { user, loading } = useAuth();
  const [pwModalOpen, setPwModalOpen] = useState(false) // 비밀번호 재설정 모달
  const [pwUserInfo, setPwUserInfo] = useState(null)  // id, seq 저장용
  const [longInactive, setLongInactive] = useState(false)  // 3개월 비밀번호미변경 여부

  useEffect(() => {
    const triggers = []

    sectionRefs.current.forEach((el) => {
      if (!el) return

      const tween = gsap.from(el, {
        y: 80,
        opacity: 0,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 80%',
          once: true,
        },
      })

      triggers.push(tween)
    })

    return () => {
      triggers.forEach(t => t.scrollTrigger?.kill())
    }
  }, [lang])

  useEffect(() => {
    if (loading) return;   // Auth 로딩중이면 대기
    if (!user) return;     // 비로그인이면 스킵
    // 3개월이상 비밀번호 미변경조회 호출
    threeMonthCheckCall();
  }, [loading, user]);

  const threeMonthCheckCall = async () => {
    // user 체크
    if (!user) {
      return;
    }

    try {
      const params = {
        publicId : user.pid,
      };
      const response = await threeMonthCheck(params);
      
      if (response?.success) {
        if (response?.data?.needChangeYn == 'Y') {
          setLongInactive(true);
          setPwUserInfo({
            id: user.pid,
          })
          setPwModalOpen(true)
        }
      }

    }
    catch (error) {
      console.error(error);
    }
  }

  return (
    <Box sx={{ overflow: 'hidden' }}>
      {/* 사업안내 */}
      <BusinessIntroSection />
      {/* 주요 강좌소개 */}
      <Box ref={(el) => (sectionRefs.current[0] = el)}><CourseIntroSection /></Box>
      {/* XR콘텐츠 소개 */}
      <Box ref={(el) => (sectionRefs.current[1] = el)}><XRContentSection /></Box>
      {/* 가상실험실습체험관 */}
      <Box ref={(el) => (sectionRefs.current[2] = el)}><VirtualLabSection /></Box>
      {/* 공유플랫폼 API */}
      <Box ref={(el) => (sectionRefs.current[3] = el)}><SharedPlatformSection /></Box>
      {/* OpenVLab 공지사항 */}
      {lang === 'ko' && (
        <Box ref={(el) => (sectionRefs.current[4] = el)}><NoticeSection /></Box>
      )}

      <PasswordChangeModal
        open={pwModalOpen}
        onClose={() => setPwModalOpen(false)}
        id={pwUserInfo?.id}
        notice={true}
        longInactive={true} 
        hideCloseButton={true}
      />
    </Box>
  )
}
